import { UnreachableCaseError } from 'ts-essentials';
import { ISlackDestinationOption } from './types';
import { SlackChannelType } from '../../utils/apollo/graphqlSchema';
import { IconWrapper, SvgIcon } from '../Icon';
import styled from 'styled-components';
import { IStyled } from '../../styles/types';

const Container = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

const DestinationIcon = ({ value }: { value: ISlackDestinationOption }) => {
  if (value.__typename === 'SlackMember') {
    return <>@</>;
  } else if (value.__typename === 'SlackChannel') {
    if (value.type === SlackChannelType.Public) {
      return <>#</>;
    } else if (value.type === SlackChannelType.Private) {
      return (
        <SvgIcon name="lock" width={16} height={16} customFill="currentColor" />
      );
    } else {
      throw new UnreachableCaseError(value.type);
    }
  } else {
    throw new UnreachableCaseError(value);
  }
};

interface IProps extends IStyled {
  value: ISlackDestinationOption;
}

const SlackDestinationLabel = ({ value, className }: IProps) => {
  return (
    <Container className={className}>
      <IconWrapper size={16}>
        <DestinationIcon value={value} />
      </IconWrapper>
      {value.name}
    </Container>
  );
};

export default SlackDestinationLabel;
